import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Login from '@/components/Login.vue'
import ROUTE_ENUM from '@/enums/route.enum'

Vue.use(VueRouter)

const routes = [
  {
    ...ROUTE_ENUM.LOGIN,
    component: Login,
  },
  {
    ...ROUTE_ENUM.HOME,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Home.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.CAMPAIGN,
    component: () => import('../views/campaign/Index.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.ADD_CAMPAIGN,
    component: () => import('../views/campaign/Add.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.EDIT_CAMPAIGN,
    component: () => import('../views/campaign/Edit.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.EDIT_CAMPAIGN_CONTENT,
    component: () =>
      import('../views/campaign/EditCampaignContent.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/campaign/pre-register/:id',
  //   name: 'PreRegister',
  //   component: () => import('../views/campaign/PreRegister.vue'),

  //   meta: {
  //     requiresAuth: true,
  //   },
  // },

  {
    ...ROUTE_ENUM.BRANCH,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/branch/Index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.ADD_BRANCH,
    component: () => import('../views/branch/Add.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.EDIT_BRANCH,
    component: () => import('../views/branch/Edit.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.ADD_BRANCH_TIME,
    component: () => import('../views/branch/AddTime.vue'),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.EDIT_BRANCH_TIME,
    component: () => import('../views/branch/EditTime.vue'),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.PRODUCT,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/product/Index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.ADD_PRODUCT,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/product/Add.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.EDIT_PRODUCT,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/product/Edit.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.COUPON,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/coupon/Index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.ADD_COUPON,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/coupon/Add.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.EDIT_COUPON,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/coupon/Edit.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.ORDER,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/order/Index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.MAIN_PRODUCT,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/main-product/Index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.ADD_MAIN_PRODUCT,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/main-product/Add.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.EDIT_MAIN_PRODUCT,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/main-product/Edit.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.PAYMENT,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/payment/Index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.EDIT_PAYMENT,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/payment/Edit.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.COUPON_PURCHASED,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/couponPurchased/Index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.ADD_COUPON_PURCHASED,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/couponPurchased/Add.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.ITEC_LOGS,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/logs/ItecLogs.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.PAYMENT_LOGS,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/logs/PaymentLogs.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.PRE_REGISTER,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/pre-register/index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
  {
    ...ROUTE_ENUM.PRE_REGISTER_CREATE_FORM,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/pre-register/create-form.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.STATIC_PAGE,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/static-page/index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.ADD_STATIC_PAGE,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/static-page/Add.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.EDIT_STATIC_PAGE,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/static-page/Edit.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.PRODUCT_QUOTA_TIME,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/product-quota-time/index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.REPORT_PRODUCT_QUOTA_TIME,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/report/report-product-quota-time.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.SMS,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/sms/Index.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },

  {
    ...ROUTE_ENUM.ORDER_HISTORY_SAMSUNG,
    component: () =>
      import(
        /* webpackChunkName: "about" */ '../views/order/report/Samsung.vue'
      ),

    meta: {
      requiresAuth: true,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  document.title = 'Pre-Order Back-Office'
  if (to.meta.requiresAuth) {
    if (!store?.getters['auth/token']) {
      next({
        name: 'Login',
      })
    } else {
      const roles = localStorage.getItem('roles')
      if (roles) {
        store.commit(
          'auth/SET_ROLES',
          JSON.parse(localStorage.getItem('roles')),
        )
      }

      // Get User Profile
      // if (!store?.state?.me?.data) {
      //   await store.dispatch('me/getUserProfile')
      // }

      // if (
      //   to.meta.stockEdit &&
      //   !store?.state?.me?.data?.permission?.stock_edit
      // ) {
      //   next({
      //     name: 'Login',
      //   })
      // } else {
      //   next()
      // }
      next()
    }
  } else {
    next()
  }
})

export default router
